module.exports = __webpack_public_path__ + "img/banner24-1.a9a51a01.jpg";